// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_unified_pack_mfe_styles" + "." + "c6e07e34" + ".chunk.css";
};